import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { serverLink } from "../../resources/url";
import {
    setApplicationDetails,
    setGeneralDetails, setLoginDetails,
} from "../../actions/actions";
import Sidebar from "../common/sidebar/sidebar";
import { toast } from "react-toastify";
import { subjects } from "../common/ssce/subjects";
import Loader from "../common/loader/loader";
import Header from "../common/header/header";

function Jamb(props) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [userData] = useState(props.applicationLogin);
    const [subjectList, setSubjectList] = useState([]);
    const [isFormLoading, setisFormLoading] = useState('off')
    const [jambData, setJambData] = useState(props.applicant_data.jamb ?? []);
    const [jambResult, setJambResult] = useState({
        matricNumber: "",
        examYear: "",
        subject1: "",
        jambScore1: 0,
        subject2: "",
        jambScore2: 0,
        subject3: "",
        jambScore3: 0,
        subject4: "",
        jambScore4: 0,
        AppID: props.applicationData.EntryID,
    });

    const allApplicationData = async () => {
        await axios
            .get(`${serverLink}application/ug/application/data/${props.applicationData.EntryID}`)
            .then((response) => {
                props.setOnApplicationDetails(response.data.application_data)
                // props.setOnGeneralDetails(response.data);
                setJambData(response.data.jamb);
                setLoading(false)
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleChange = (e) => {
        if (e.target.id.includes("jambScore"))
            setJambResult({ ...jambResult, [e.target.id]: parseInt(e.target.value) });
        else setJambResult({ ...jambResult, [e.target.id]: e.target.value });
    };

    useEffect(() => {
        const fetchSubjects = async () => {
            await axios
                .get(`${serverLink}registration/admissions/subject/list`)
                .then((result) => {
                    if (result.data.length > 0) {
                        setSubjectList(result.data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        };

        fetchSubjects();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (props.applicationData.AdmissionType === "UTME") {
            for (let value in jambResult) {
                if (jambResult[value] === "") {
                    toast.error(`${value} can't be empty`);
                    return false;
                }
            }
        }

        if(jambResult.matricNumber === "" || jambResult.examYear === ""){
            toast.error("please fill all fields");
            return false;
        }
        // Check for duplicate subjects
        const subjects = [
            jambResult.subject1,
            jambResult.subject2,
            jambResult.subject3,
            jambResult.subject4
        ];

        const hasDuplicate = new Set(subjects).size !== subjects.length;

        if (hasDuplicate) {
            toast.error("You cannot select the same subject more than once");
            return false;
        }

        setisFormLoading('on')
        await axios
            .post(`${serverLink}application/jamb/result`, jambResult)
            .then((response) => {
                if (response.data.message === "success") {
                    toast.success(`Jamb Result Added`);
                    allApplicationData();
                    onNext();
                    setisFormLoading('off')
                } else {
                    toast.error(
                        `Something went wrong uploading jamb result. Please try again!`
                    );
                    setisFormLoading('off')
                }
            })
            .catch((error) => {
                toast.error(
                    `Something went wrong. Please check your connection and try again!`
                );
            });
    };

    const handleNewEntry = async () => {
        await axios
            .delete(
                `${serverLink}application/jamb/delete/${props.applicationData.EntryID}`
            )
            .then((res) => {
                if (res.data.message === "success") {
                    allApplicationData();
                }
            })
            .catch((err) => {
                console.log("NETWORK ERROR", err);
            });
    };

    const onPrevious = () => {
        navigate("/undergraduate/secondary-school-result");
    };

    const onNext = () => {
        navigate("/undergraduate/guardian-information");
    };

    useEffect(() => {
        allApplicationData();
    }, [])

    let jamb_total_score = 0;
    let jamb_requirement_total_score = 0;

    if (jambData.length > 0) {
        jamb_total_score = jambData.reduce((sum, jamb) => sum + parseInt(jamb.SubjectScore || 0), 0);
    }

    if (props.jambRequirement.length > 0) {
        jamb_requirement_total_score = props.jambRequirement.reduce((sum, jamb) => sum + parseInt(jamb.Score || 0), 0);
    }

    return loading ? (
        <Loader />
    ) : (
        <div className="main-wrapper">
            <Header/>
            <Sidebar />
            <div className="page-wrapper">
                <div className="content">
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                            <div className="my-auto mb-2">
                                <h3 className="page-title mb-1">Welcome, {`${userData.FirstName} ${userData.MiddleName} ${userData.Surname}`
                                }</h3>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <a href="">Dashboard</a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">Jamb Result</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
            <div className="row">
                <div className="col 9">
                    <div className="register">
                        {jambData.length < 1 ? (
                            <form className="login bg-white  shadow p-5 mb-6" onSubmit={handleSubmit}>
                                <h5 className="mb-3">{props.applicationData.AdmissionType} Details</h5>
                                {
                                    props.applicationData.AdmissionType === "UTME"
                                    ?
                                    <>
                                        <div className="row">
                                            {/* Left side: Form - col-9 */}
                                            <div className="col-md-9 mb-3">
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="matricNumber" className="form-label">
                                                                Registration Number <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="matricNumber"
                                                                className="form-control"
                                                                placeholder="Registration Number"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 mb-3">
                                                        <div className="form-group">
                                                            <label htmlFor="examYear" className="form-label">
                                                                Examination Year <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                id="examYear"
                                                                min={1980}
                                                                max={new Date().getFullYear()}
                                                                className="form-control"
                                                                placeholder="Examination Year"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Subject 1 */}
                                                    <div className="col-8">
                                                        <div className="form-group">
                                                            <label htmlFor="subject1" className="form-label">
                                                                Subject <span className="text-danger">*</span>
                                                            </label>
                                                            <select
                                                                id="subject1"
                                                                name="subject"
                                                                className="form-control"
                                                                onChange={handleChange}
                                                            >
                                                                <option value="">Select Option</option>
                                                                {subjectList.map((s, i) => (
                                                                    <option key={i} value={s.Subject}>
                                                                        {s.Subject}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-4 mb-3">
                                                        <div className="form-group">
                                                            <label htmlFor="jambScore1" className="form-label">
                                                                Score <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                id="jambScore1"
                                                                name="score"
                                                                min={0}
                                                                max={100}
                                                                onChange={handleChange}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Subject 2 */}
                                                    <div className="col-8">
                                                        <div className="form-group">
                                                            <label htmlFor="subject2" className="form-label">
                                                                Subject <span className="text-danger">*</span>
                                                            </label>
                                                            <select
                                                                id="subject2"
                                                                name="subject"
                                                                className="form-control"
                                                                onChange={handleChange}
                                                            >
                                                                <option value="">Select Option</option>
                                                                {subjectList.map((s, i) => (
                                                                    <option key={i} value={s.Subject}>
                                                                        {s.Subject}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-4 mb-3">
                                                        <div className="form-group">
                                                            <label htmlFor="jambScore2" className="form-label">
                                                                Score <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                id="jambScore2"
                                                                name="score"
                                                                min={0}
                                                                max={100}
                                                                onChange={handleChange}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Subject 3 */}
                                                    <div className="col-8">
                                                        <div className="form-group">
                                                            <label htmlFor="subject3" className="form-label">
                                                                Subject <span className="text-danger">*</span>
                                                            </label>
                                                            <select
                                                                id="subject3"
                                                                name="subject"
                                                                className="form-control"
                                                                onChange={handleChange}
                                                            >
                                                                <option value="">Select Option</option>
                                                                {subjectList.map((s, i) => (
                                                                    <option key={i} value={s.Subject}>
                                                                        {s.Subject}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-4 mb-3">
                                                        <div className="form-group">
                                                            <label htmlFor="jambScore3" className="form-label">
                                                                Score <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                id="jambScore3"
                                                                name="score"
                                                                min={0}
                                                                max={100}
                                                                onChange={handleChange}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Subject 4 */}
                                                    <div className="col-8">
                                                        <div className="form-group">
                                                            <label htmlFor="subject4" className="form-label">
                                                                Subject <span className="text-danger">*</span>
                                                            </label>
                                                            <select
                                                                id="subject4"
                                                                name="subject"
                                                                className="form-control"
                                                                onChange={handleChange}
                                                            >
                                                                <option value="">Select Option</option>
                                                                {subjectList.map((s, i) => (
                                                                    <option key={i} value={s.Subject}>
                                                                        {s.Subject}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-4 mb-3">
                                                        <div className="form-group">
                                                            <label htmlFor="jambScore4" className="form-label">
                                                                Score <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                id="jambScore4"
                                                                name="score"
                                                                min={0}
                                                                max={100}
                                                                onChange={handleChange}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Total */}
                                                    <div className="col-md-12 mt-3">
                                                        <div className="alert alert-info">
                                                            TOTAL: {jambResult.jambScore1 + jambResult.jambScore2 + jambResult.jambScore3 + jambResult.jambScore4}
                                                        </div>
                                                    </div>

                                                    {/* Note */}
                                                    <div className="col-md-12 mt-3">
                                                        <div className="alert alert-info">
                                                            NB: UTME cut off mark is {jamb_requirement_total_score}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Right side: Requirement table - col-3 */}
                                            <div className="col-md-3">
                                                <h4 className="mb-2">UTME required combination and score</h4>
                                                <table className="table table-bordered pt-5">
                                                    <thead>
                                                    <tr>
                                                        <th>Subject</th>
                                                        <th>Score</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {props.jambRequirement.length > 0 && props.jambRequirement.map((jamb, index) => (
                                                        <tr key={index}>
                                                            <td>{jamb.Subject}</td>
                                                            <td>{jamb.Score}</td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                    <tfoot>
                                                    <tr>
                                                        <th>Total:</th>
                                                        <th>{jamb_requirement_total_score}</th>
                                                    </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>


                                        <div className="col-md-12 mt-3 mb-2">
                                    {isFormLoading === 'on' ?
                                        <button className="btn btn-dark text-center offset-3 w-50" id="kt_modal_new_address_submit">
                                                    <span className="indicator-progress">Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2" />
                                                </span>
                                        </button>
                                        :
                                        <div className="filters-group mb-lg-4 text-center">
                                            <button className="btn btn-dark mx-3 active" onClick={onPrevious}> Previous</button>
                                            <button className="btn btn-dark w-50  active" type="submit">  Save and Continue</button>
                                        </div>
                                    }
                                </div>
                                    </>
                                        :
                                        <button className="btn btn-dark w-50 active" onClick={onNext}>  Next</button>
                                }
                            </form>
                        ) : (
                            <>
                                {jambData.length > 0 && (
                                    <>
                                        <h4>Registration Number: {jambData[0]?.MatricNumber}</h4>
                                        <h4>Exam Year: {jambData[0]?.ExaminationYear}</h4>
                                        <button
                                            className="btn btn-secondary btn-sm float-end"
                                            onClick={handleNewEntry}
                                        >
                                            Reset Score
                                        </button>
                                        <div className="mt-5">
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <h4 className="mb-2">My Input</h4>
                                                    <table className="table table-bordered pt-5">
                                                        <thead>
                                                        <tr>
                                                            <th>Subject</th>
                                                            <th>Score</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {jambData.map((jamb, index) => (
                                                            <tr key={index}>
                                                                <td>{jamb.SubjectName}</td>
                                                                <td>{jamb.SubjectScore}</td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                        <tfoot>
                                                        <tr>
                                                            <th>Total:</th>
                                                            <th>{jamb_total_score}</th>
                                                        </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>

                                                <div className="col-md-6">
                                                    <h4  className="mb-2">UTME requirement subjects and score</h4>
                                                    <table className="table table-bordered pt-5">
                                                        <thead>
                                                        <tr>
                                                            <th>Subject</th>
                                                            <th>Score</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {props.jambRequirement.length > 0 && props.jambRequirement.map((jamb, index) => (
                                                            <tr key={index}>
                                                                <td>{jamb.Subject}</td>
                                                                <td>{jamb.Score}</td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                        <tfoot>
                                                        <tr>
                                                            <th>Total:</th>
                                                            <th>{jamb_requirement_total_score}</th>
                                                        </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-3 mb-2 pb-5">
                                            <div className="filters-group mb-lg-4 text-center">
                                                <button className="btn btn-dark mx-3 active" onClick={onPrevious}> Previous</button>
                                                <button className="btn btn-dark w-50  active" onClick={onNext}>  Save and Continue</button>
                                            </div>
                                        </div>

                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
                </div>
            </div>
        </div>
    );
}
const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
        applicant_data: state.generalDetails,
        applicationData: state.applicationDetails,
        jambRequirement: state.JambRequirementsDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setGeneralDetails(p));
        },
        setOnApplicationDetails: (p) => {
            dispatch(setApplicationDetails(p));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Jamb);
